export default __webpack_public_path__ + "static/media/icon-close.f964824b.svg";